import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Autocomplete, TextField, createFilterOptions } from '@mui/material';
import { useHtsActions, useHtsData } from 'src/context/providers/HtsContext';

const filterOptions = createFilterOptions({
  limit: 50,
  stringify: (hts) => `${hts.code} ${hts.name}`,
});

const HtsAutocomplete = ({ value, onChange, label, size, disabled, error, helperText }) => {
  const { htsCodes, loading } = useHtsData();
  const { getHtsCodes } = useHtsActions();

  useEffect(() => {
    if (!htsCodes.length) getHtsCodes();
  }, [htsCodes.length, getHtsCodes]);

  const selected = htsCodes.find((hts) => hts.code === value) ?? null;

  return (
    <Autocomplete
      options={htsCodes}
      value={selected}
      loading={loading}
      disabled={disabled}
      size={size}
      filterOptions={filterOptions}
      getOptionLabel={(hts) => `${hts.code} — ${hts.name}`}
      isOptionEqualToValue={(option, current) => option.id === current.id}
      onChange={(_, hts) => onChange(hts)}
      renderInput={(params) => (
        <TextField {...params} label={label} error={error} helperText={helperText} />
      )}
    />
  );
};

HtsAutocomplete.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.node,
};

HtsAutocomplete.defaultProps = {
  value: null,
  label: 'HTS code',
  size: 'medium',
  disabled: false,
  error: false,
  helperText: undefined,
};

export default HtsAutocomplete;
